import { Component, OnInit } from '@angular/core';
import { TariffService } from '../ApiServices/tariff.service';
import { TARIFF } from '../Models/master-tariff';
import { ShowHideLoaderService } from '../Shared/show-hide-loader.service';
import { ToasterService } from '../Shared/toaster.service';
import { Router } from '@angular/router';
import { MasterParkingDevice } from '../Models/master-device';
import { DeviceService } from '../ApiServices/device.service';
import { parseDate } from 'ngx-bootstrap/chronos';

@Component({
  selector: 'app-tariff-tester',
  templateUrl: './tariff-tester.component.html',
  styleUrls: ['./tariff-tester.component.css']
})
export class TariffTesterComponent implements OnInit {

  constructor(private tariffService: TariffService, private loader: ShowHideLoaderService, private toasterService: ToasterService, private router: Router, private deviceService: DeviceService) { }
  selectedDevice: number;
  deviceList: MasterParkingDevice[] = [];
  entryDate: string;
  exitDate: string;
  tariff: TARIFF = new TARIFF();
  ngOnInit(): void {
    var token = sessionStorage.getItem('token');
    if (token == null) {
      this.router.navigateByUrl('/');
      return;
    } else {
      this.deviceService.getDevices().subscribe((resp) => {

        this.deviceList = resp;
        this.loader.ShowHide(false);
        this.toasterService.Success("Devices Loaded", "Info");

      }, (error) => {

        this.loader.ShowHide(false);
        this.toasterService.Warning(error, "Warning");
      }
      );
    }
  }
  ShowTariff() {
    this.loader.ShowHide(true);
    this.tariff = new TARIFF();
    this.tariff.DEVICE_ID = this.selectedDevice;
    this.tariff.ENTRY_DATE_TIME = this.entryDate;
    this.tariff.Exit_DATE_TIME = this.exitDate;
    this.tariffService.TariffCalculate(this.tariff).subscribe((tariff) => {

      this.tariff.VALUE = tariff.VALUE;
      this.loader.ShowHide(false);

    }, (err) => {
      this.loader.ShowHide(false);
      this.toasterService.Warning(err, "Warning");

    });

  }
}
